import { baseApi } from './baseApi';
import { ServiceTypes } from '../constants';

enum RequestIds {
  UPLOAD = 'UPLOAD',
}

export const uploadService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createUploadRequest: builder.mutation<IUploadRequestApiResponse, { data: ICreateUploadRequestPayload }>({
      query: ({ data }) => ({
        url: `/upload-requests`,
        method: 'POST',
        body: data,
      }),
      transformResponse: (result: IApiResponse<IUploadRequestApiResponse>) => result.data,
      invalidatesTags: () => [{ type: ServiceTypes.UPLOAD, id: RequestIds.UPLOAD }],
    }),
    markUploadStatusCompleted: builder.mutation<IUploadRequestApiResponse, { requestId: number }>({
      query: ({ requestId }) => ({
        url: `/upload-requests/${requestId}`,
        method: 'PATCH',
        body: {
          upload_completed: true,
        },
      }),
      transformResponse: (result: IApiResponse<IUploadRequestApiResponse>) => result.data,
      invalidatesTags: () => [{ type: ServiceTypes.UPLOAD, id: RequestIds.UPLOAD }],
    }),
    getUploadStatusById: builder.query<IUploadRequestApiResponse, { requestId: number }>({
      query: ({ requestId }) => `/upload-requests/${requestId}`,
      transformResponse: (result: IApiResponse<IUploadRequestApiResponse>) => result.data,
      providesTags: (result, error, { requestId }) => [{ type: 'Types', id: `STATUS_${requestId}` }],
    }),
    uploadFile: builder.mutation({
      query: ({ url, file }) => ({
        url: url,
        method: 'PUT',
        body: file,
      }),
      invalidatesTags: () => [{ type: ServiceTypes.UPLOAD, id: RequestIds.UPLOAD }],
    }),
  }),
});

export const {
  useGetUploadStatusByIdQuery,
  useLazyGetUploadStatusByIdQuery,
  useUploadFileMutation,
  useCreateUploadRequestMutation,
  useMarkUploadStatusCompletedMutation,
} = uploadService;
